
(function() {

  function findVariant(card) {
    var variants = JSON.parse(card.dataset.variants);
    var selects = card.querySelectorAll('.mpu-selector__option-select');

    var selectedOptions = [];

    selects.forEach(function(select) {
      selectedOptions[parseInt(select.dataset.optionPosition)] = select.value;
    });

    return variants.find(function(v) {
      return v.option1 === (selectedOptions[0] || null) &&
             v.option2 === (selectedOptions[1] || null) &&
             v.option3 === (selectedOptions[2] || null);
    });
  }

  function updateCard(card, variant) {
    if (!variant) return;

    card.dataset.selectedVariantId = variant.id;

    var price = card.querySelector('.mpu-selector__price');
    var compare = card.querySelector('.mpu-selector__compare-price');
    var button = card.querySelector('.mpu-selector__atc-btn');

    if (price) {
      price.textContent = variant.price;
    }

    if (compare) {
      if (variant.compare_at_price) {
        compare.textContent = variant.compare_at_price;
        compare.style.display = '';
      } else {
        compare.style.display = 'none';
      }
    }

    if (button) {
      button.disabled = !variant.available;
      button.textContent = variant.available
        ? 'In den Warenkorb'
        : 'Ausverkauft';
    }
  }

  async function addToCart(variantId, button) {

    if (!variantId) return;

    button.disabled = true;
    button.textContent = 'Wird hinzugefügt...';

    try {

      var formData = new FormData();

      formData.append('id', variantId);
      formData.append('quantity', 1);
      formData.append('sections', 'cart-drawer,cart-icon-bubble');
      formData.append('sections_url', window.location.pathname);

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      });

      const data = await response.json();

      const cartDrawer = document.querySelector('cart-drawer');

      if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
        cartDrawer.renderContents(data);
        cartDrawer.open();
      }

      document.dispatchEvent(
        new CustomEvent('cart:update')
      );

    } catch (error) {
      console.error(error);
    }

    button.disabled = false;
    button.textContent = 'In den Warenkorb';
  }

  document.querySelectorAll(
    '.mpu-selector__option-select'
  ).forEach(function(select) {

    select.addEventListener('change', function() {

      var card = this.closest(
        '.mpu-selector__card'
      );

      var variant = findVariant(card);

      if (variant) {
        updateCard(card, variant);
      }

    });

  });

  document.querySelectorAll(
    '.mpu-selector__atc-btn'
  ).forEach(function(button) {

    button.addEventListener('click', function(e) {

      e.preventDefault();

      var card = this.closest(
        '.mpu-selector__card'
      );

      addToCart(
        card.dataset.selectedVariantId,
        this
      );

    });

  });

  document.querySelectorAll(
    '.mpu-selector__card'
  ).forEach(function(card) {

    var variant = findVariant(card);

    if (variant) {
      updateCard(card, variant);
    }

  });

})();
